@if (message != null) {
  <div class="w-100" [ngClass]="cssClass" [attr.id]="id" [innerHtml]="isCollapsible ? showLongText ? messageLong : message : message" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft"></div>
  @if (isCollapsible) {
    <button type="button" class="btn btn-primary btn-pretty" (click)="collapseTextClick()">
      @if (!showLongText) {
        <span i18n="@@WidgetTextShowMore">Show More</span>
      }
      @if (showLongText) {
        <span i18n="@@WidgetTextShowLess">Show Less</span>
      }
    </button>
  }
}